
import React from 'react';
import { Button } from '@/components/ui/button';
import { Check, X, Edit } from 'lucide-react';
import { Input } from '@/components/ui/modern-form/Input';

interface TarifaActionsProps {
  clienteId: string;
  editingTarifa: number;
  originalTarifa: number;
  onTarifaChange: (clienteId: string, value: string) => void;
  onSaveTarifa: (clienteId: string) => void;
  onUndoTarifa: (clienteId: string) => void;
}

const TarifaActions: React.FC<TarifaActionsProps> = ({
  clienteId,
  editingTarifa,
  originalTarifa,
  onTarifaChange,
  onSaveTarifa,
  onUndoTarifa
}) => {
  const isEditing = editingTarifa !== originalTarifa;
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onTarifaChange(clienteId, e.target.value);
  };

  return (
    <div className="flex items-center justify-end space-x-2">
      <Input
        type="number"
        value={editingTarifa}
        onChange={handleChange}
        step="0.0001"
        min="0"
        className="w-28 h-9 text-right text-sm focus:border-blue-300 focus:ring-blue-50"
      />
      
      {isEditing ? (
        <>
          <Button
            onClick={() => onSaveTarifa(clienteId)}
            size="sm"
            variant="ghost"
            className="h-8 w-8 p-0 text-green-500 hover:text-green-600 hover:bg-green-50 rounded-full"
          >
            <Check className="h-4 w-4" />
          </Button>
          <Button
            onClick={() => onUndoTarifa(clienteId)}
            size="sm"
            variant="ghost"
            className="h-8 w-8 p-0 text-red-500 hover:text-red-600 hover:bg-red-50 rounded-full"
          >
            <X className="h-4 w-4" />
          </Button>
        </>
      ) : (
        <Button
          size="sm"
          variant="ghost"
          className="h-8 w-8 p-0 text-blue-400 hover:text-blue-600 hover:bg-blue-50 rounded-full"
          onClick={() => onSaveTarifa(clienteId)}
        >
          <Edit className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default TarifaActions;
